export const dolphinJokes = [
  // Klassieke Dutch moppen
  "Wat is de snelste manier om geld te verliezen? Wedden dat je sneller kunt denken dan een dolfijn.",
  "Waarom kon de zeeman niet kaartspelen? Omdat hij altijd op het dek stond.",
  "Wat zegt een koe in het donker? Mooooooo... ik zie niks.",
  "Mijn vrouw zei dat ik moest stoppen met doen alsof ik een flamingo ben. Ik moest toch ergens een grens trekken.",
  "Ik heb een grap over papier, maar die scheur ik je niet aan.",
  "Mijn hond heeft boekhoudkunde gestudeerd. Hij zit nu op zijn account.",
  "Waarom eet een zeehond geen toast? Die heeft liever hapjes.",
  "Wat is het verschil tussen een dakpan en een postzegel? Je kunt een postzegel likken, maar een dakpan liever niet.",
  "Twee antennes trouwden. De bruiloft was niet zo bijzonder, maar de receptie was geweldig.",
  "Ik vroeg aan de bibliotheekmedewerker of ze boeken over paranoia hadden. Ze fluisterde: 'Ze staan achter je.'",
  "Wat doe je met een zieke chemicus? Als je niets kunt doen, helium.",
  "Ik wilde een grap vertellen over oneindigheid, maar ik wist niet waar ik moest beginnen.",
  "Wat zei de ene muur tegen de andere? Ik zie je op de hoek.",
  "Mijn opa zei altijd: 'Vechten lost niets op.' Geweldige opa. Verschrikkelijke bokstrainer.",
  "Wat is de overeenkomst tussen een fietser en een journalist? Ze hebben allebei belletjes.",
  "Waarom dragen geesten nooit leugens? Omdat ze doorzichtig zijn.",
  "Dokter: 'U heeft nog maar tien te leven.' Patiënt: 'Tien wat?!' Dokter: 'Negen...'",
  "Ik vroeg mijn kat of hij van muziek hield. Hij keek me aan en liep weg. Hij is meer een jazz-fan.",
  "Hoeveel planners heb je nodig om een lamp te vervangen? Eén, maar die moet het wel inplannen.",

  // Waterscouting & dolfijnen
  "Waarom gaan dolfijnen nooit naar school? Omdat ze bang zijn voor de haai-men.",
  "Wat zei de zee tegen het strand? Niks, ze zwaaide gewoon.",
  "Een scout gaat zwemmen in het meer. Hij zinkt. Dat verklaart waarom hij WATER-scout is.",
  "Waarom nam de zeeverkenner een potlood mee op het water? Om de horizon te tekenen.",
  "Hoe groet een waterscouter zijn vrienden? Met een natte handdruk.",
  "Waarom zijn dolfijnen zo blij? Omdat ze nooit in de regen worden gevangen.",
  "Wat zei de golf tegen het surfboard? Ik ben zo fan van jou, ik gooide mezelf aan je voeten.",
  "Waarom zijn waterscouters zulke goede koks? Ze weten precies hoe ze dingen in het water moeten gooien.",
];
